import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * The applied params, as the server renders them from the URL: a JSON object string, or an
   * object from a Vue host — `{"availability":"true","available_date":"2026-09-20"}`. The date
   * mode is derived from it: `available_date` selects the specific day (or today, when it carries
   * the `today-tz:` form) and `available_days` the days of the week. A falsy value clears every
   * selection; the filter's own `FormData` echoing back is ignored.
   *
   * @type {Object|String}
   */
  modelValue: {
    type: [Object, String, FormData],
    default: undefined,
  },
  /**
   * Leave `visit_types` to the standalone visit-type filter: no visit-type select renders and the
   * param is neither submitted nor advertised in `filterNames`.
   * `DoctorFinderEmbed#visit_type_filter_owns_param?` decides it.
   *
   * @type {Boolean|String}
   */
  noVisitTypes: booleanAttribute(),
  /**
   * Hide the online-booking switch. Filtering is then on only while a sub-filter is set.
   *
   * @type {Boolean|String}
   */
  hideOnlineBookingOption: booleanAttribute(),
  /**
   * The per-domain link the today card's button opens. The card renders only while a client
   * provides its copy (`today_title`, `today_text`, `today_link_label`) or this link.
   */
  todayLinkHref: {
    type: String,
    default: undefined,
  },
  /** Endpoint override for the visit-type options. */
  visitTypesUrl: {
    type: String,
    default: undefined,
  },
  /**
   * The availability endpoint the specific-day calendar reads its day indicators from. Omitted,
   * the calendar renders without indicators.
   */
  indicatorUrl: {
    type: String,
    default: undefined,
  },
  /**
   * Per-category titles for the top-level visit-type rows, keyed by category
   * (`{"in-person": "In-person visits only"}`). Arrives as a JSON string from the server.
   *
   * @type {Object|String}
   */
  categoryLabels: {
    type: [Object, String],
    default: undefined,
  },
  prependIcon: {
    type: String,
    default: "calendar-filled",
  },
  /** @type {Boolean|String} */
  open: booleanAttribute(),
  /** @type {Boolean|String} */
  nonClearable: booleanAttribute(),
});
